import { useNavigate } from 'react-router-dom';

export function TestLoadError({ message }: { message: string }) {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col min-h-screen max-w-lg mx-auto bg-bg-main p-6">
      <h1 className="text-xl font-bold text-incorrect mb-4">Error</h1>
      <p className="text-title mb-2">{message}</p>
      <button
        onClick={() => navigate('/courses')}
        className="mt-4 bg-accent-purple text-white px-4 py-2 rounded-lg"
      >
        Back to Courses
      </button>
    </div>
  );
}
